export default __webpack_public_path__ + "static/media/Intuit_Transparent3.dd1a1907.png";